import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { RefreshCw, Edit, Trash2 } from 'lucide-react';

export function QuotationHistoryTab({ savedQuotations, loadingQuotations, fetchSavedQuotations, loadSavedQuotation, handleDeleteQuotation }) {
  return (
    <Card>
      <CardHeader className="py-3 flex flex-row items-center justify-between">
        <CardTitle className="text-base">Saved Quotations</CardTitle>
        <Button variant="outline" size="sm" onClick={fetchSavedQuotations} disabled={loadingQuotations} data-testid="qt-refresh-history">
          <RefreshCw className={`w-4 h-4 mr-2 ${loadingQuotations ? 'animate-spin' : ''}`} /> Refresh
        </Button>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Ref</TableHead><TableHead>Style No</TableHead><TableHead>Ver</TableHead>
              <TableHead>Date</TableHead><TableHead>Client</TableHead><TableHead>Piece</TableHead>
              <TableHead className="text-right">USD</TableHead><TableHead className="text-right">INR</TableHead>
              <TableHead className="text-center">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loadingQuotations ? (
              <TableRow><TableCell colSpan={9} className="text-center py-8 text-slate-400">Loading...</TableCell></TableRow>
            ) : savedQuotations.length === 0 ? (
              <TableRow><TableCell colSpan={9} className="text-center py-8 text-slate-400">No saved quotations yet</TableCell></TableRow>
            ) : savedQuotations.map(q => (
              <TableRow key={q.id} data-testid={`qt-history-row-${q.id}`}>
                <TableCell className="font-mono text-xs">{q.ref}</TableCell>
                <TableCell className="text-xs font-medium">{q.style_no || '\u2014'}</TableCell>
                <TableCell className="text-xs text-center">{q.version || '\u2014'}</TableCell>
                <TableCell className="text-sm">{new Date(q.created_at).toLocaleDateString()}</TableCell>
                <TableCell className="font-medium">{q.client_name}</TableCell>
                <TableCell className="capitalize">{q.piece_type}</TableCell>
                <TableCell className="text-right">${q.final_cost_usd?.toFixed(2)}</TableCell>
                <TableCell className="text-right font-medium text-amber-600">{'\u20b9'}{q.final_cost_inr?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</TableCell>
                <TableCell className="text-center">
                  <Button variant="ghost" size="sm" onClick={() => loadSavedQuotation(q.id)} data-testid={`qt-history-load-${q.id}`}><Edit className="w-4 h-4" /></Button>
                  <Button variant="ghost" size="sm" className="text-red-500" onClick={() => handleDeleteQuotation(q.id)} data-testid={`qt-history-delete-${q.id}`}><Trash2 className="w-4 h-4" /></Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
